// @ts-nocheck
import logoPeople from './images/people.png';
import logoChinanews from './images/chinanews.png';
import logoGmw from './images/gmw.png';
import logoKuaikeduo from './images/kuaikeduo.jpg';
import logoYouth from './images/youth.png';
import logoWeather from './images/weather.png';
import logoChinadaily from './images/chinadaily.png';
import logo1905 from './images/1905.png';
import logoZhixue from './images/zhixue.png';
import logo56 from './images/56.png';
import logoSogou from './images/sogou.png';
import logoSohu from './images/sohu.png';
import logoYicai from './images/yicai.png';
import logoCankaoxiaoxi from './images/cankaoxiaoxi.jpeg';

export const logoData = [
  {
    alt: '手机人民网',
    src: logoPeople,
    link: 'http://m.people.cn/'
  },
  {
    alt: '中国新闻网',
    src: logoChinanews,
    link: 'http://www.chinanews.com/'
  },
  {
    alt: '光明网',
    src: logoGmw,
    link: 'http://www.gmw.cn/'
  },
  {
    alt: '快客多',
    src: logoKuaikeduo,
    link: 'http://kuaikeduo.kuaizhan.com/'
  },
  {
    alt: '中国青年网',
    src: logoYouth,
    link: 'http://www.youth.cn/'
  },
  {
    alt: '中国天气',
    src: logoWeather,
    link: 'http://www.weather.com.cn'
  },
  {
    alt: '中国日报',
    src: logoChinadaily,
    link: 'http://cn.chinadaily.com.cn'
  },
  {
    alt: '电影网',
    src: logo1905,
    link: 'http://www.1905.com'
  },
  {
    alt: '智学网',
    src: logoZhixue,
    link: 'https://www.zhixue.com/login.html'
  },
  {
    alt: '我乐网',
    src: logo56,
    link: 'http://www.56.com/'
  },
  {
    alt: '搜狐',
    src: logoSohu,
    link: 'http://www.sohu.com/'
  },
  {
    alt: '搜狗阅读',
    src: logoSogou,
    link: 'http://k.sogou.com'
  },
  {
    alt: '第一财经',
    src: logoYicai,
    link: 'https://www.yicai.com/'
  },
  {
    alt: '参政消息',
    src: logoCankaoxiaoxi,
    link: 'http://www.cankaoxiaoxi.com/'
  }
]
